module.exports = "/images/pergamumAlto.svg?402cdf31a66df515eb792911460b52f6";